import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import NcDmvService from '../../../../../service/NcDmvService';
import DetailedNcDmvModal from './NcDmvModal';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

class NcDmv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renewalRows: [],
      renewalHeaders: [],
      pendingRows: [],
      pendingHeaders: [],
    };

    this.comboFields = [
      {
        value: 'transactionId',
        display: 'Transaction ID',
      },
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'plateNumber',
        display: 'Plate Number',
      },
    ];
  }

  onRenewalSelect(row) {
    const { renewalRows = [], } = this.state;
    const selectedRenewal = renewalRows.find(renewal => renewal.raw.id === row.id);
    this.setState({
      selectedRenewal: selectedRenewal.raw,
    });
  }

  onPendingSelect(row) {
    const { pendingRows = [], } = this.state;
    const selectedPendingRenewal = pendingRows.find(renewal => renewal.raw.id === row.id);
    this.setState({
      selectedPendingRenewal: selectedPendingRenewal.raw,
    });
  }

  getRenewalActivity(event) {
    const { search, combo, } = event;
    this.reset();
    const vm = this;
    const renewalRows = [];
    const renewalHeaders = [];
    const pendingHeaders = [];
    const pendingRows = [];

    const criteria = {};
    criteria[combo.value] = search.value;

    const allowedKeys = [
      'id',
      'dueDate',
      'transactionTimestamp',
      'transactionId',
      'customerId',
      'plateNumber',
      'year',
      'make',
      'model',
    ];

    NcDmvService.getNcDmvRenewalsBySearchCriteria(criteria)
      .then((response) => {
        const { renewals, } = response.data;
        if (renewals.length > 0) {
          renewals.forEach((renewal) => {
            const filtered = _.pick(renewal, allowedKeys);
            filtered.dueDate = moment(filtered.dueDate).utc().format();
            filtered.transactionTimestamp = moment(filtered.transactionTimestamp).utc().format();
            const row = Object.values(filtered);
            row.push(renewal.refunds.length === 0 ? 'false' : 'true');
            renewalRows.push({
              value: row,
              raw: renewal,
            });
          });
          allowedKeys.forEach((allowedKey) => {
            renewalHeaders.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
          renewalHeaders.push({ value: 'refunded', display: 'Refunded', });
        }

        vm.setState({
          renewalHeaders,
          renewalRows,
        });
      })
      .catch((err) => {
        console.error(err);
      });

    NcDmvService.getNcDmvPendingRenewalsBySearchCriteria(criteria)
      .then((response) => {
        const { pendingRenewals, } = response.data;
        let filteredPendingRenewals;

        if (pendingRenewals.length > 0) {
          filteredPendingRenewals = pendingRenewals.filter((pending) => {
            if (!renewalRows.find(renewal => renewal.id === pending.id) && renewalRows.length > 0) {
              return false;
            }
            return true;
          });

          filteredPendingRenewals.forEach((pendingRenewal) => {
            const filtered = _.pick(pendingRenewal, allowedKeys);
            filtered.dueDate = moment(filtered.dueDate).utc().format();
            filtered.transactionTimestamp = moment(filtered.transactionTimestamp).utc().format();
            const row = Object.values(filtered);
            pendingRows.push({ value: row, raw: pendingRenewal, });
          });
          allowedKeys.forEach((allowedKey) => {
            pendingHeaders.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
        }
        this.setState({
          pendingRows,
          pendingHeaders,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay = (renewal) => {
    if (!renewal) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${renewal.id}`}</p>
        <p>{`Transaction ID: ${renewal.transactionId}`}</p>
        <p>{`Customer ID: ${renewal.customerId}`}</p>
        <hr />
        <DetailedNcDmvModal renewal={renewal} />
      </div>
    );
  };

  reset() {
    this.setState({
      renewalRows: [],
      renewalHeaders: [],
      pendingRows: [],
      pendingHeaders: [],
      selectedPendingRenewal: null,
      selectedRenewal: null,
    });
  }

  render() {
    const {
      renewalHeaders = [],
      renewalRows = [],
      pendingRows = [],
      pendingHeaders = [],
      selectedRenewal,
      selectedPendingRenewal,
    } = this.state;
    const style = {
      maxHeight: '400px',
      overflowY: 'auto',
    };
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getRenewalActivity(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Renewals">
            <Grid
              headers={renewalHeaders}
              rows={renewalRows}
              style={style}
              onRowSelect={data => this.onRenewalSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedRenewal)}
        </div>
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Pending Renewals">
            <Grid
              headers={pendingHeaders}
              rows={pendingRows}
              style={style}
              onRowSelect={data => this.onPendingSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedPendingRenewal)}
        </div>
      </div>
    );
  }
}

export default NcDmv;
